<div class="wrapper" [ngClass]="{ selected: selected() }" (click)="setSelected()">
  @if (baseCurrency$ | async) {
    <div class="fiat">
      <p class="balance">{{ balanceFiat$ | async | number: '1.2-2' }}</p>
      <p class="fiat-code">{{ (baseCurrency$ | async).code }}</p>
    </div>
  } @else {
    <div class="crypto">
      <p class="balance">{{ walletBalance().balance | cryptoBalance: walletBalance().wallet }}</p>
      <icon [name]="walletBalance().wallet.code" color="primary-color" size="24" />
    </div>
  }
</div>
@if (onSelect$ | async) {}
